import { render, staticRenderFns } from "./RightBottom.vue?vue&type=template&id=1da323be"
import script from "./RightBottom.vue?vue&type=script&lang=js"
export * from "./RightBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports